var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { constants } from 'day8-ui';
import { fetchWeekAutomaticDiscounts } from '../actions/booking';
import { filterBookingOptions } from '../actions/bookingOptions';
import { resolveDiscountForSubjectAndPackage, setAutomaticDiscountData } from '../helpers/automaticDiscounts';
import { store } from '../store/configureStore';
var AUTOMATIC_DISCOUNT_CAMPAIGN_DATA = constants.AUTOMATIC_DISCOUNT_CAMPAIGN_DATA;
export var initialValues = {
    discountData: {},
    getDiscountForWeekAndSubject: function () { return null; },
    hasActiveDiscounts: false,
    AUTOMATIC_DISCOUNT_CAMPAIGN_DATA: AUTOMATIC_DISCOUNT_CAMPAIGN_DATA,
    error: null
};
export var AutomaticDiscountsContext = createContext(initialValues);
export var AutomaticDiscountsProvider = function (_a) {
    var children = _a.children;
    var _b = useState({}), discountData = _b[0], setDiscountData = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var updateAutomaticDiscountsData = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var data, normalizedData, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchWeekAutomaticDiscounts()];
                case 1:
                    data = _a.sent();
                    normalizedData = Object.fromEntries(Object.entries(data).map(function (_a) {
                        var _b;
                        var key = _a[0], value = _a[1];
                        var weekData = value;
                        var discounts;
                        if (Array.isArray(weekData === null || weekData === void 0 ? void 0 : weekData.discounts)) {
                            discounts = weekData.discounts.map(function (d) {
                                var _a;
                                return ({
                                    discountPercentage: Number((_a = d.discountPercentage) !== null && _a !== void 0 ? _a : 0),
                                    enabledBookingSubjects: Array.isArray(d.enabledBookingSubjects) ? d.enabledBookingSubjects : [],
                                    isOnFullOrder: Boolean(d.isOnFullOrder),
                                    enabledPackages: Array.isArray(d.enabledPackages) ? d.enabledPackages.map(Number) : [],
                                    isActiveOnNonStandardBookings: Boolean(d.isActiveOnNonStandardBookings)
                                });
                            });
                        }
                        else if ((weekData === null || weekData === void 0 ? void 0 : weekData.discountPercentage) != null || (weekData === null || weekData === void 0 ? void 0 : weekData.enabledBookingSubjects) != null) {
                            discounts = [{
                                    discountPercentage: Number((_b = weekData.discountPercentage) !== null && _b !== void 0 ? _b : 0),
                                    enabledBookingSubjects: Array.isArray(weekData.enabledBookingSubjects) ? weekData.enabledBookingSubjects : [],
                                    isOnFullOrder: Boolean(weekData.isOnFullOrder),
                                    enabledPackages: Array.isArray(weekData.enabledPackages) ? weekData.enabledPackages.map(Number) : [],
                                    isActiveOnNonStandardBookings: Boolean(weekData.isActiveOnNonStandardBookings)
                                }];
                        }
                        else {
                            discounts = [];
                        }
                        return [Number(key), { discounts: discounts }];
                    }));
                    setDiscountData(normalizedData);
                    setAutomaticDiscountData(normalizedData);
                    store.dispatch(filterBookingOptions());
                    setError(null);
                    return [2 /*return*/, normalizedData];
                case 2:
                    e_1 = _a.sent();
                    console.error(e_1);
                    setError('Failed to fetch discount data.');
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        var interval = null;
        // Initial fetch
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var initialData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, updateAutomaticDiscountsData()];
                    case 1:
                        initialData = _a.sent();
                        // Only set interval if discounts data exists
                        if (initialData && Object.keys(initialData).length > 0) {
                            interval = setInterval(updateAutomaticDiscountsData, 30000); // Fetch every 30 seconds
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
        return function () {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [updateAutomaticDiscountsData]);
    var getDiscountForWeekAndSubject = useCallback(function (weekId, subject, packageId, isNonStandard) {
        if (isNonStandard === void 0) { isNonStandard = false; }
        return resolveDiscountForSubjectAndPackage(discountData, weekId, subject, packageId, isNonStandard);
    }, [discountData]);
    var hasActiveDiscounts = useMemo(function () { return Object.values(discountData).some(function (w) { var _a, _b; return ((_b = (_a = w === null || w === void 0 ? void 0 : w.discounts) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0; }); }, [discountData]);
    var contextValue = useMemo(function () { return ({
        discountData: discountData,
        getDiscountForWeekAndSubject: getDiscountForWeekAndSubject,
        hasActiveDiscounts: hasActiveDiscounts,
        error: error,
        AUTOMATIC_DISCOUNT_CAMPAIGN_DATA: AUTOMATIC_DISCOUNT_CAMPAIGN_DATA
    }); }, [discountData, getDiscountForWeekAndSubject, hasActiveDiscounts, error]);
    return (React.createElement(AutomaticDiscountsContext.Provider, { value: contextValue }, children));
};
export var useAutomaticDiscounts = function () { return useContext(AutomaticDiscountsContext); };
